import React from "react";
import { useNavigate } from "react-router-dom";
import LabelCom from "./LabelCom";
import styles from "./CommonFunctions.module.less";

const CommonFunctions = () => {
  const navigate = useNavigate();

  const functions = [
    { 
      title: "学习手册", 
      icon: require("@/images/home/function_1.png"),
      path: "/picture/ebook" 
    },
    { 
      title: "趣味动画", 
      icon: require("@/images/home/function_2.png"),
      path: "/picture/funAnimation" 
    },
    { 
      title: "磨耳音频", 
      icon: require("@/images/home/function_3.png"),
      path: "/listeningAudio" 
    },
    { 
      title: "入门评估", 
      icon: require("@/images/home/function_4.png"),
      path: "/introTest" 
    },
  ];

  const handleClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className={styles["common-functions"]}>
      <LabelCom title="常用功能" />
      <div className={styles["functions-container"]}>
        {functions.map((item, index) => (
          <div 
            key={index} 
            className={styles["function-item"]}
            onClick={() => handleClick(item.path)}
          >
            <img
              src={item.icon}
              alt={item.title}
              className={styles["function-icon"]}
            />
            <div className={styles["function-title"]}>{item.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommonFunctions;
